// Header scroll
const header = document.getElementById('header');
window.addEventListener('scroll', () => {
  header.classList.toggle('scrolled', window.scrollY > 10);
}, { passive: true });

// Mobile menu
const burger = document.getElementById('burger');
const mobileMenu = document.getElementById('mobile-menu');
const menuClose = document.getElementById('menu-close');
if (burger) burger.addEventListener('click', () => { mobileMenu.classList.add('open'); document.body.style.overflow = 'hidden'; });
if (menuClose) menuClose.addEventListener('click', closeMobileMenu);
function closeMobileMenu() { mobileMenu.classList.remove('open'); document.body.style.overflow = ''; }

// Fade up
const fadeEls = document.querySelectorAll('.fade-up');
const observer = new IntersectionObserver((entries) => {
  entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add('visible'); observer.unobserve(e.target); } });
}, { threshold: 0.1 });
fadeEls.forEach(el => observer.observe(el));

// Stagger fade
const staggerEls = document.querySelectorAll('.fade-up-stagger');
const staggerObs = new IntersectionObserver((entries) => {
  entries.forEach(e => {
    if (e.isIntersecting) {
      const i = Array.from(staggerEls).indexOf(e.target);
      setTimeout(() => e.target.classList.add('visible'), i * 100);
      staggerObs.unobserve(e.target);
    }
  });
}, { threshold: 0.1 });
staggerEls.forEach(el => staggerObs.observe(el));

// Carousel
(function() {
  const track = document.getElementById('carouselTrack');
  if (!track) return;
  const dots = document.querySelectorAll('#carouselDots .carousel-dot');
  const total = dots.length;
  let current = 0;
  function goTo(index) {
    current = (index + total) % total;
    track.style.transform = 'translateX(-' + (current * 100) + '%)';
    dots.forEach((d, i) => d.classList.toggle('active', i === current));
  }
  const prev = document.getElementById('carouselPrev');
  const next = document.getElementById('carouselNext');
  if (prev) prev.addEventListener('click', () => goTo(current - 1));
  if (next) next.addEventListener('click', () => goTo(current + 1));
  dots.forEach(dot => dot.addEventListener('click', () => goTo(+dot.dataset.index)));
})();
